module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 100 100"}},[_c('title',[_v("Artboard 10")]),_c('path',{attrs:{"d":"M50 18a32 32 0 1 0 32 32 32 32 0 0 0-32-32zm4 49h-8V47h8zm0-26h-8v-8h8z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/info_icon.svg
// module id = 273
// module chunks = 2